import React from 'react';
import { Text, View } from "../../Components/Themed"
import type { EventProps, MatchProps, OrderProps, PublicPlayerProps, TournamentProps } from "../../types"
import { FlatList, Image } from 'react-native';
import moment from 'moment-mini';
import OrderGradeBar from '../../MarketComponents/components/OrderGradeBar';
import { CampaignHelpers } from '../api';
import { MarketComponentHelpers } from '../../MarketComponents/api';
import { Icons } from '../../Components';
import { useColors } from '../../constants/useColors';

type ActionListProps = {
    orders:OrderProps[],
    events:EventProps[],
    tournaments:TournamentProps[],
    matches:MatchProps[],
    hide_header?:boolean,
    players:PublicPlayerProps[]
}

const ActionList = ({ orders, events, players, tournaments, matches, hide_header }:ActionListProps) => {
    const Colors = useColors();
    const renderAction = (data:{ item:OrderProps, index:number }) => {
        const event = events.find(e => e.event_id == data.item.event_id);
        const tournament = tournaments.find(t => t.tournament_id == data.item.event_id);
        const match = matches.find(m => m.match_id == data.item.event_id);
        const { contest_title } = CampaignHelpers.getContestDetails(data.item.event_type, event, tournament, match);

        const player = players.find(p => p.player_id == data.item.player_id)
        return (
            <View float style={{ margin:5 }}>
                <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:8, borderTopRightRadius:8, borderTopLeftRadius:8 }}>
                    <Text style={{ flex:1 }} theme='h2'>{contest_title}</Text>
                    <Text theme='action'>{moment(data.item.create_datetime).fromNow()}</Text>
                </View>
                <View transparent style={{ flexDirection:'row', alignItems:'center', padding:10 }}>
                    {player ?
                    <Image
                        source={{ uri: player.profile_pic && player.profile_pic != '' ? player.profile_pic : 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp' }}
                        style={{ height:35, width:35, borderRadius:100 }}
                        resizeMode='cover'
                    />
                    :<></>}
                    <View transparent style={{ flex:1, marginLeft:10 }}>
                        <Text theme='h1'>{data.item.title}</Text>
                        <Text theme='description'>@{player?.username}</Text>
                    </View>
                    {data.item.status == 'approved' && data.item.grade ?
                    <View transparent style={{ padding:5, marginRight:10 }}>
                        <OrderGradeBar
                            grade={data.item.grade}
                            view_type='book'
                        />
                    </View>
                    :
                    <View transparent>
                        <Text theme='h1'>{MarketComponentHelpers.getOddsLabel(data.item.odds)}</Text>
                    </View>
                    }
                </View>
            </View>
        )
    }


    return (
        <View transparent style={{ flex:1 }}>
            {!hide_header ?
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10 }}>
                <Icons.ActivityIcon size={20} color={Colors.text.h1} />
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h1'>Recent Action</Text>
                    <Text theme='description' style={{ marginTop:3 }}>Action placed while checked in</Text>
                </View>
            </View>
            :<></>}
            <View>
                <FlatList
                    data={orders}
                    renderItem={renderAction}
                    keyExtractor={(item) => item.order_id.toString()}
                    key={'campaign_action'}
                />
            </View>
        </View>
    )
}

export default ActionList